import React from "react";
import styled from "styled-components";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import BoneCarvingImage from "../../../../img/bonecarving.png";

const BoneCarvingProjectSection = styled(ProjectSection)`
  background: rgb(88, 50, 20);
`;

function BoneCarving() {
  return (
    <BoneCarvingProjectSection>
      <ProjectTitle title="Bone Carving" tag="Since 1989" />
      <ProjectDescription>
        Since 1989, I’ve been fascinated by a book called Bone Carving, which featured intricate designs, particularly
        the main piece on its cover. Over the years, from intermediate school through to high school and later in
        life, I’ve continued carving and improving my technique.
      </ProjectDescription>

      <ProjectHeroImage src={BoneCarvingImage} desktop lazy />
    </BoneCarvingProjectSection>
  );
}

export default BoneCarving;
